const ROLE_DISPLAY_NAMES: Record<string, string> = {
    administrator: "Admin",
    admin: "Admin",
    staff: "Staff",
    coach: "Coach",
    athlete: "Athlete",
    guardian: "Guardian",
    polaris: "Polaris",
    manager: "Manager",
    viewer: "Viewer",
};

function titleCaseEnum(name: string): string {
    const lower = name.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/** Maps backend role enums to user-facing labels. API values are unchanged. */
export function formatRoleLabel(name?: string | null): string {
    const trimmed = (name ?? "").trim();
    if (!trimmed || trimmed === "—") {
        return "—";
    }
    const mapped = ROLE_DISPLAY_NAMES[trimmed.toLowerCase()];
    return mapped ?? titleCaseEnum(trimmed);
}

/** Instant Chat may only be granted to school administrators and staff. */
export function isSchoolChatRole(name?: string | null): boolean {
    const lower = (name ?? "").trim().toLowerCase();
    return lower === "administrator"
        || lower === "admin"
        || lower === "staff"
        || lower === "coach"
        || lower === "manager"
        || lower === "viewer";
}
